// Under den här fönsterhöjden får sidomenyn inte plats med sina vanliga mått, till exempel på en laptop.
// Då krymper avstånden och raderna, men textstorleken är densamma.
export const SIDEBAR_COMPACT_QUERY = '@media (max-height: 860px)';

// På riktigt låga fönster krymper raderna ännu mer, så att alla menyval får plats ned till 600 px.
export const SIDEBAR_TIGHT_QUERY = '@media (max-height: 700px)';

export const SIDEBAR_ITEM_SX = {
  mb: 0.75,
  [SIDEBAR_COMPACT_QUERY]: { mb: 0.5 },
  [SIDEBAR_TIGHT_QUERY]: { mb: 0.25 },
} as const;

export const getSidebarItemButtonSx = (dense?: boolean) =>
  ({
    minHeight: dense ? 38 : 46,
    [SIDEBAR_COMPACT_QUERY]: { minHeight: dense ? 32 : 38, py: 0 },
    [SIDEBAR_TIGHT_QUERY]: { minHeight: dense ? 32 : 36 },
  } as const);
